<template>
  <PageTemplate>
    <h1>Invoices</h1>
    <v-card title="Outstanding Invoices">
      <v-table
        :table="outstanding"
      />
    </v-card>
    <!--<v-card title="Paid Invoices">
      <v-table
        :table="paid"
      />
    </v-card>-->
  </PageTemplate>
</template>
<script>
    import PageTemplate from "../templates/Page/index.vue";
    import Card from "@/molecules/Card";
    import Table from "@/molecules/Table";
    import flatPicker from "flatpickr";
    import "flatpickr/dist/flatpickr.css";
    import "flatpickr/dist/themes/airbnb.css";
    import {columnFilter, columnSort, amountSort, dateSort_ddmmyyyy} from "../common/tableFunctions"
    import {GET_INVOICES} from "../store/actions.type";
    import constants from "@/common/constants";
    import routes from "@/common/routes";

    export default {
        name: "Invoices",
        components: {
            "v-table": Table,
            "v-card": Card,
            PageTemplate,
        },
        data() {
            return {
                outstanding: {
                    columns: [
                        {
                            label: 'Invoice ID',
                            field: 'invoice_id',
                            sortFn: columnSort,
                            thClass: 'sortable',
                            filterOptions: {
                                enabled: true,
                                placeholder: 'Invoice ID',
                                filterFn: columnFilter
                            },
                        },
                        {
                            label: 'Invoice Type',
                            field: 'type',
                            sortFn: columnSort,
                            thClass: 'sortable',
                            filterOptions: {
                                enabled: true,
                                placeholder: 'Invoice Type',
                                filterFn: columnFilter
                            },
                        },
                        {
                            label: 'Transaction Date',
                            field: 'dueBy',
                            sortFn: dateSort_ddmmyyyy,
                            thClass: 'sortable',
                            filterOptions: {
                                enabled: true,
                                placeholder: 'Select',
                                filterFn: columnFilter
                            },
                        },
                        {
                            label: 'Facility Name',
                            field: 'facility_name',
                            sortFn: columnSort,
                            thClass: 'sortable',
                        },
                        {
                            label: 'Job Number',
                            field: 'job_number',
                            sortFn: columnSort,
                            thClass: 'sortable',
                            filterOptions: {
                                enabled: true,
                                placeholder: 'Job Number',
                                filterFn: columnFilter
                            },
                        },
                        {
                            label: 'Amount Due',
                            field: 'amount_due',
                            sortFn: amountSort,
                            thClass: 'sortable shrink-cell text--right',
                            tdClass: 'bold text--right',
                            filterOptions: {
                                enabled: true,
                                placeholder: 'Amount Due',
                                filterFn: columnFilter
                            },
                        },
                    ],
                    rows: [],
                    totalRecords: 0
                },
                //removed paid invoices
                // paid: {
                //     columns: [
                //         {
                //             label: 'Invoice ID',
                //             field: 'invoice_id',
                //             sortFn: columnSort,
                //             thClass: 'sortable',
                //             filterOptions: {
                //                 enabled: true,
                //                 placeholder: 'Invoice ID',
                //                 filterFn: columnFilter
                //             },
                //         },
                //         {
                //             label: 'Invoice Type',
                //             field: 'type',
                //             sortFn: columnSort,
                //             thClass: 'sortable',
                //             filterOptions: {
                //                 enabled: true,
                //                 placeholder: 'Invoice Type',
                //                 filterFn: columnFilter
                //             },
                //         },
                //         {
                //             label: 'Paid on',
                //             field: 'paidOn',
                //             sortFn: dateSort,
                //             thClass: 'sortable',
                //             filterOptions: {
                //                 enabled: true,
                //                 placeholder: 'Select',
                //                 filterFn: columnFilter
                //             },
                //         },
                //         {
                //             label: 'Facility Name',
                //             field: 'facility_name',
                //             sortFn: columnSort,
                //             thClass: 'sortable',
                //         },
                //         {
                //             label: 'Job Number',
                //             field: 'job_number',
                //             sortFn: columnSort,
                //             thClass: 'sortable',
                //             filterOptions: {
                //                 enabled: true,
                //                 placeholder: 'Job Number',
                //                 filterFn: columnFilter
                //             },
                //         },
                //         {
                //             label: 'Amount Due',
                //             field: 'amount_due',
                //             sortFn: amountSort,
                //             thClass: 'sortable shrink-cell text--right',
                //             tdClass: 'bold text--right',
                //             filterOptions: {
                //                 enabled: true,
                //                 placeholder: 'Amount Due',
                //                 filterFn: columnFilter
                //             },
                //         },
                //     ],
                //     rows: [],
                //     totalRecords: 0
                // },
            };
        },
        computed:{
            invoices(){
                return this.$store.state.invoices.invoices;
            },
        },
        created() {
          this.constants = constants;
        },
        mounted() {
            let inputs = [
                'input[placeholder="Select"]',
            ];
            inputs.forEach(function(input){
                flatPicker(input,{
                    dateFormat: "d/m/Y",
                    allowInput: true,
                    theme: "light"
                });
            });
            this.updateBreadCrumb();
            this.getInvoices();
        },
        methods: {
            updateBreadCrumb: function() {
                this.$store.dispatch('updateBreadCrumbAction', [{ name: 'Dashboard', link: routes.DASHBOARD },{ name: 'Invoices' }]);
            },
            getInvoices:function () {
                this.$store.dispatch(GET_INVOICES,localStorage.getItem(constants.CURRENT_ROLE)).then(response => {
                    this.outstanding.rows = this.invoices.outstandingInvoices;
                    //removed paid invoices
                    //this.paid.rows = this.invoices.paidInvoices;
                });
            }
        }
    }
</script>


